import styled from "styled-components";

export const ProductCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  overflow: hidden;
  margin: 1rem;
  height: 350px;
  width: 300px;
  position: relative;

  background: ${p => p.theme.colors.background.paper};
  box-shadow: ${p => p.theme.shadows[2]};
  border: 1px solid rgba(255, 255, 255, 0.18);
  transition: box-shadow 0.5s ease-in-out, border 0.5s ease-in-out;
  &:hover {
    box-shadow: ${p => p.theme.shadows[10]};
    border: 1px solid ${p => p.theme.colors.action.border};
  }
`;
